import React from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { 
	Button,
    Icon
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from "notistack";

import http from "../../lib/http-common";
import { loginSocial } from '../../store/slices/auth';

const GoogleLoginBtn = (props) => {

    const history = useHistory();
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();

    const login = useGoogleLogin({
        onSuccess: async (response) => {
            try {
                props.setOpen(true); 
                const res = await http.get(
                    "https://www.googleapis.com/oauth2/v3/userinfo",
                    {
                        headers: {
                            Authorization: `Bearer ${response.access_token}`
                        }
                    }
                );
                if(res) {
                    const formData = new FormData();
                    
                    formData.append('first_name', res.data.given_name);
                    formData.append('last_name', res.data.family_name);
                    formData.append('email', res.data.email);
                    formData.append('picture', res.data.picture);
                    formData.append('provider', 'google');
                    formData.append('provider_id', res.data.sub);

                    dispatch(loginSocial(formData))
                        .unwrap()
                        .then((res) => {
                            props.setOpen(false);
                            if(res.token) {
                                if(props.isModal) {
                                    window.location.reload();
                                } else {
                                    history.push("/user/dashboard");
                                    window.location.reload();
                                }
                            }
                        })
                        .catch((error) => {
                            if(error) {
                                props.setOpen(false); 
                                enqueueSnackbar('Woops! Something went wrong!', {
                                    variant: 'error',
                                    autoHideDuration: 5000,
                                });
                            }
                        })

                }
            } catch(error) {
                if(error) {
                    props.setOpen(false); 
                    enqueueSnackbar('Woops! Something went wrong!', {
                        variant: 'error',
                        autoHideDuration: 5000,
                    });
                }
            }   
        },
        onError: (error) => {
            props.setOpen(false); 
            enqueueSnackbar('Woops! Something went wrong!', {
                variant: 'error',
                autoHideDuration: 5000,
            });            
        }
    });

    return (
        <>
            <Button
                variant="contained"
                color="secondary"
                size="medium"
            //    disabled={loader}
                onClick={() => login()} 
                startIcon={<Icon>g_translate</Icon>}
                fullWidth={true}
            >
                Continue with Google
            </Button>
        </>
    );
};

export default GoogleLoginBtn;